
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2 5h28v22H2V5zm2 2v12.875l7-7 .719.719 5.75 5.813L22 14.876l.719.719L28 20.908V7.002H4zm20 2a2 2 0 11.001 3.999A2 2 0 0124 9zm-13 6.719l-7 7V25h16.188zm11 2l-3.125 3.094 4.156 4.188H28V23.72z"}})])
          )
        }
      }
    